import React from 'react';
import {useNavigate} from 'react-router-dom';
import {
	PassportDrawer,
	ProfileAlertsBanner,
	ProfileDocumentsList,
	TaxIdentifierDrawer,
	useProfileDocuments,
	type ProfileDocumentItem,
} from 'features/profile';
import {ROUTES} from 'app/router/routes';
import styles from './ProfileDataPage.module.css';

const backIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M10 6L4 12L10 18" stroke="currentColor" strokeWidth="1.6" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 12.9135L5 12.9135L5 11.1992L20 11.1992L20 12.9135Z"
			fill="currentColor"
		/>
	</svg>
);

export function ProfileDocumentsPage(): React.ReactElement {
	const navigate = useNavigate();
	const {documents, passport, isLoading, isError} = useProfileDocuments();
	const [isTaxDrawerOpen, setIsTaxDrawerOpen] = React.useState(false);
	const [isPassportDrawerOpen, setIsPassportDrawerOpen] = React.useState(false);

	const taxDocument = documents.find((document) => document.id === 'inn');

	const handleDocumentClick = (document: ProfileDocumentItem) => {
		if (document.id === 'inn') {
			setIsTaxDrawerOpen(true);
			return;
		}

		if (document.id === 'passport') {
			setIsPassportDrawerOpen(true);
		}
	};

	return (
		<div className={styles.root}>
			<header className={styles.header}>
				<button
					type="button"
					className={styles.backButton}
					onClick={() => navigate(ROUTES.profile)}
					aria-label="Назад"
				>
					{backIcon}
				</button>
				<h1 className={styles.title}>Документы</h1>
			</header>

			<div className={styles.content}>
				<div className={styles.contentInner}>
					<ProfileAlertsBanner />
					<section className={styles.documentsSection} aria-labelledby="profile-documents-main-title">
						<h2 id="profile-documents-main-title" className={styles.sectionTitle}>
							Основные
						</h2>

						{isLoading ? <p className={styles.stateText}>Загрузка документов...</p> : null}
						{isError ? <p className={styles.errorText}>Не удалось загрузить документы</p> : null}
						{!isLoading && !isError ? (
							<ProfileDocumentsList documents={documents} onDocumentClick={handleDocumentClick} />
						) : null}
					</section>
				</div>
			</div>

			<TaxIdentifierDrawer
				open={isTaxDrawerOpen}
				value={taxDocument?.value ?? '—'}
				onClose={() => setIsTaxDrawerOpen(false)}
			/>

			<PassportDrawer
				open={isPassportDrawerOpen}
				passport={passport}
				onClose={() => setIsPassportDrawerOpen(false)}
			/>
		</div>
	);
}
